// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Spinner = require("../../../uikit/reason/atoms/Spinner/Spinner.bs.js");
let Tooltip = require("../../common/Tooltip.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Attachments = require("../../common/Attachments/Attachments.bs.js");
let FileInputLink = require("../../../v5/common/attachments/FileInputLink.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");
let VisuallyHidden = require("@reach/visually-hidden").default;

function ConversationInput__Attachments$ConversationAttachmentItem$Tooltip(props) {
  let uploadState = props.uploadState;
  let tmp;
  tmp = typeof uploadState !== "object" ? (
      uploadState === "Success" ? "Click to remove" : "Upload failed. Click to remove"
    ) : uploadState._0.toString() + `%`;
  return JsxRuntime.jsx(Tooltip.make, {
    label: tmp,
    children: props.children
  });
}

let Tooltip$1 = {
  make: ConversationInput__Attachments$ConversationAttachmentItem$Tooltip
};

function ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton(props) {
  let onPress = props.onPress;
  let uploadState = props.uploadState;
  let tmp;
  tmp = typeof uploadState !== "object" ? (
      uploadState === "Success" ? JsxRuntime.jsx(IconV5.make, {
          icon: "cancel",
          size: 10
        }) : JsxRuntime.jsx(IconV5.make, {
          icon: "attention-alt",
          size: 12,
          className: "text-tan-error-500"
        })
    ) : JsxRuntime.jsx(Spinner.make, {
      size: 10,
      stroke: "black"
    });
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ConversationInput__Attachments$ConversationAttachmentItem$Tooltip, {
      uploadState: uploadState,
      children: JsxRuntime.jsxs(ReactAriaComponents.Button, {
        children: [
          JsxRuntime.jsx(VisuallyHidden, {
            children: props.title
          }),
          JsxRuntime.jsx("span", {
            children: tmp,
            "aria-hidden": true,
            className: "pointer-events-none flex"
          })
        ],
        className: param => {
          let tmp;
          tmp = typeof uploadState !== "object" && uploadState !== "Success" ? "border-tan-error-500" : "border-zinc-400";
          return TailwindMerge.twMerge([
            "bg-white border rounded-full cursor-pointer p-[5px] text-black hover:bg-zinc-100",
            tmp
          ]);
        },
        onClick: e => onPress(e),
        type: "button"
      })
    }),
    className: "absolute -top-2.5 -right-2.5"
  });
}

let RemoveButton = {
  make: ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton
};

function ConversationInput__Attachments$ConversationAttachmentItem(props) {
  let onDeleteAttachment = props.onDeleteAttachment;
  let upload = props.upload;
  let match = upload.state;
  let uploadState;
  switch (match.TAG) {
    case "NotStarted" :
      uploadState = {
        TAG: "InProgress",
        _0: 0
      };
      break;
    case "InProgress" :
      uploadState = {
        TAG: "InProgress",
        _0: match._1 * 100
      };
      break;
    case "Failed" :
      uploadState = "Error";
      break;
    case "Success" :
      uploadState = "Success";
      break;
  }
  let content = Attachments.Attachment.isImage(upload) ? ({
      NAME: "Image",
      VAL: upload.previewUrl
    }) : ({
      NAME: "File",
      VAL: Attachments.Attachment.fileName(upload)
    });
  let tmp;
  if (content.NAME === "File") {
    let tmp$1;
    tmp$1 = typeof uploadState !== "object" ? "" : "opacity-60";
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "file",
          size: 20,
          className: "text-zinc-700"
        }),
        JsxRuntime.jsx("span", {
          children: content.VAL,
          className: "text-zinc-700 font-bold"
        })
      ],
      className: TailwindMerge.twMerge([
        "flex flex-row items-center gap-1 bg-zinc-300 px-2.5 py-1.5 rounded",
        tmp$1
      ])
    });
  } else {
    let tmp$2;
    tmp$2 = typeof uploadState !== "object" ? "" : "opacity-60";
    tmp = JsxRuntime.jsx("img", {
      className: TailwindMerge.twMerge([
        "w-[50px] h-[50px] rounded-md object-cover",
        tmp$2
      ]),
      src: content.VAL
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      tmp,
      JsxRuntime.jsx(ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton, {
        uploadState: uploadState,
        onPress: param => onDeleteAttachment(Attachments.Attachment.id(upload)),
        title: "Remove " + Attachments.Attachment.fileName(upload)
      })
    ],
    className: "relative"
  });
}

let ConversationAttachmentItem = {
  Tooltip: Tooltip$1,
  RemoveButton: RemoveButton,
  make: ConversationInput__Attachments$ConversationAttachmentItem
};

function ConversationInput__Attachments$AddButton(props) {
  return JsxRuntime.jsx(FileInputLink.make, {
    onChange: props.onAddAttachment,
    multiple: true,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("span", {
          children: "+",
          "aria-hidden": true
        }),
        JsxRuntime.jsx(VisuallyHidden, {
          children: "Attach images and files"
        })
      ],
      className: "border border-zinc-300 rounded-full bg-white text-zinc-600 hover:border-tan-blue-500 hover:bg-tan-blue-500 hover:text-white transition-colors duration-150 w-8 h-8 cursor-pointer flex items-center justify-center pb-[5px] text-4xl font-light"
    })
  });
}

let AddButton = {
  make: ConversationInput__Attachments$AddButton
};

function ConversationInput__Attachments(props) {
  let onDeleteAttachment = props.onDeleteAttachment;
  let match = Belt_Array.partition(props.uploads, Attachments.Attachment.isImage);
  return JsxRuntime.jsxs("div", {
    children: [
      match[0].map(upload => JsxRuntime.jsx(ConversationInput__Attachments$ConversationAttachmentItem, {
        upload: upload,
        onDeleteAttachment: onDeleteAttachment
      }, Attachments.Attachment.id(upload))),
      match[1].map(upload => JsxRuntime.jsx(ConversationInput__Attachments$ConversationAttachmentItem, {
        upload: upload,
        onDeleteAttachment: onDeleteAttachment
      }, Attachments.Attachment.id(upload)))
    ],
    className: "flex flex-row flex-wrap gap-4 mb-4"
  });
}

let make = ConversationInput__Attachments;

exports.ConversationAttachmentItem = ConversationAttachmentItem;
exports.AddButton = AddButton;
exports.make = make;
/* IconV5 Not a pure module */
